import { Card, Form, Stack } from "react-bootstrap";
import CustomerEmail from "./CustomerEmail";
import CustomerName from "./CustomerName";
import InvoiceForm from "./InvoiceForm";

const PaymentDetails = () => {
 
    return (

        <Card>
            <Card.Body>
                <Card.Title>Dane płatności</Card.Title>
                <Form>
                    <Stack className="mt-4" gap={3}>
                        <CustomerEmail />
                        <CustomerName />
                        <InvoiceForm />
                    </Stack>
                </Form>
            </Card.Body>
        </Card>

    );
}

export default PaymentDetails;